let map;

function initMap() {
    if (typeof lat !== 'undefined') {
        const mapOptions = {
            mapId: '8a18704e4d451524',
            zoom: 16,
            center: { lat: lat, lng: lng },
            disableDefaultUI: true
        };

        map = new google.maps.Map(document.getElementById('map'), mapOptions);

        const marker = new google.maps.Marker({
            position: { lat: lat, lng: lng },
            map: map,
        });
    }
}